import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";
import { ErrorMessageEnum } from "../shared/enums/error-message.enum";

interface InputErrorMessageProps {
    errors: FieldErrors<FieldValues>;
    name: string;
}

const InputErrorMessage = ({ errors, name }: InputErrorMessageProps) => {
    return <span>{errors[name]?.type === "required" || name === "pin" ? ErrorMessageEnum.REQUIRED : errors[name]?.message}</span>;
};

export default InputErrorMessage;
